<div
  class="modal fade"
  id="modalNeuropsychologie"
  tabindex="-1"
  aria-labelledby="modalNeuropsychologieLabel"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="modalNeuropsychologieLabel">
          Neuropsychologie
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <h4><b>Définition:</b></h4>
        <p>
          La neuropsychologie est une branche de la psychologie qui se concentre
          sur la relation entre le cerveau et le comportement. Elle étudie
          comment les blessures, les maladies et d'autres troubles du cerveau
          influencent nos pensées, nos émotions et notre comportement. Les
          neuropsychologues utilisent des tests spéciaux pour évaluer les
          fonctions cérébrales et aident les patients à comprendre et à gérer
          les changements qui surviennent dans leur cerveau. Leur objectif est
          d'améliorer la qualité de vie en aidant les gens à surmonter les
          difficultés liées aux problèmes cérébraux.
        </p>
        <br />
        <p>
          Passage des bilans cognitifs pour le dépistage des troubles de
          l'attention, de la mémoire et des fonctions exécutives auprès des
          enfants et des adultes à partir de 6 ans.
        </p>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
          (click)="goToHelp()"
        >
          En savoir plus
        </button>
      </div>
    </div>
  </div>
</div>
